var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{attrs:{"label":_vm.label,"readonly":_vm.readonly,"disabled":_vm.disabled,"dense":_vm.dense,"hide-details":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }